export default __webpack_public_path__ + "static/vision2Mobile-2548b77fb4dcb67f8cbe3dd1da38919d.png";